export const authKey = (address: string) => `auth2:${address.toLowerCase()}`
